import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendar } from '@fortawesome/free-regular-svg-icons/faCalendar'
import React from 'react'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { ScheduleBar } from '../../ScheduleBar/ScheduleBar'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { selectOneSystemAction } from '../../../store/selectors/systemActionsSelectors'
import { withTooltip } from 't4b-core-frontend'
import { showScheduleBar } from '../../../store/actions/rightBarActions'

interface ScheduleBtnProps {
    guid: string
    isDisabled?: boolean
}

export const ScheduleBtn = (props: ScheduleBtnProps) => {
    const { guid, isDisabled } = props
    const dispatch = useAppDispatch()

    const hasGetJobSchedule = useAppSelector(
        selectOneSystemAction(guid, 'get_job_schedule')
    )

    const disabled = isDisabled || !hasGetJobSchedule

    const handleShowScheduler = () => {
        dispatch(
            showScheduleBar({
                rightBarItem: <ScheduleBar guid={guid} />,
            })
        )
    }

    const btn = (
        <button
            className="rounded-blue-btn"
            onClick={handleShowScheduler}
            disabled={disabled}
        >
            <FontAwesomeIcon
                icon={faCalendar}
                color="white"
            />
        </button>
    )

    return !disabled ? withTooltip(btn, 'Launch schedule', 'scheduleBtn') : btn
}
